import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useGame } from "@/context/GameContext";
import { redeemPromo } from "@/lib/payments";
import { Sound } from "@/lib/sound";
import { Ticket } from "lucide-react";
import { toast } from "sonner";

const PromoCodeForm = ({ onDone }) => {
  const { setUnlocked, setPaywallOpen } = useGame();
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const redeem = async () => {
    if (!code.trim()) return;
    setBusy(true);
    try {
      const res = await redeemPromo(code);
      Sound.fanfare();
      setUnlocked("promo", res);
      toast.success(`Promo ${res.code} applied — all businesses unlocked!`);
      setPaywallOpen(false);
      onDone?.();
    } catch (e) {
      Sound.error();
      const st = e?.response?.status;
      toast.error(st === 429 ? "Too many tries — please wait 15 minutes." : st === 404 ? "That promo code isn't valid." : "Codes are 4-24 letters or numbers.");
    }
    setBusy(false);
  };

  if (!open) {
    return (
      <button onClick={() => { Sound.click(); setOpen(true); }} data-testid="promo-code-link" className="text-amber-600 hover:underline inline-flex items-center gap-1">
        <Ticket className="w-3.5 h-3.5" /> Have a promo code?
      </button>
    );
  }
  return (
    <div className="flex gap-2 w-full" data-testid="promo-form">
      <Input
        value={code}
        onChange={(e) => setCode(e.target.value.toUpperCase())}
        placeholder="PROMO CODE"
        className="rounded-xl border-2 border-amber-300 font-black tracking-widest uppercase"
        data-testid="promo-code-input"
        onKeyDown={(e) => e.key === "Enter" && redeem()}
        autoFocus
      />
      <Button onClick={redeem} disabled={busy || !code.trim()} data-testid="promo-submit-btn" className="bg-amber-400 hover:bg-amber-500 text-slate-900 font-heading font-black rounded-xl border-2 border-amber-500">
        {busy ? "…" : "Apply"}
      </Button>
    </div>
  );
};

export default PromoCodeForm;
